module.exports = "pegasus_template/assets/share-email.png";